module.exports = __webpack_public_path__ + "img/t5-teal.11dc1da9.png";